<template lang="pug">
div.gallery(v-if="content.key.length > 0")
	div.swiper-container
		div.swiper-wrapper
			div.swiper-slide(v-for="item in content.key")
				img(v-bind:src="item.image")
	div.swiper-pagination(v-if="content.key.length > 1")
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'

export default {
	name: 'Gallery',
	props: ['content'],
	data() {
		return {
			slider: null,
			settings: {
				speed: 600,
				loop: false,
				slidesPerView: 1,
				spaceBetween: 0,
				autoHeight: false,
				pagination: {
					clickable: true
				}
			}
		}
	},
	methods: {
		initSlider(){
			this.settings.pagination.el = '.gallery .swiper-pagination';
			this.slider = new Swiper('.gallery .swiper-container', this.settings);
		}
	},
	mounted() {
		// console.log(this.content);
		setTimeout(() => this.initSlider(), 20);
	}
}
</script>



// WEBPACK FOOTER //
// src/components/features/Gallery/index.vue